import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PersonModel from 'tio-common/models/person';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderDashboardIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const loanSummary = await this.store
      .adapterFor('user')
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      .getLoanSummary(this.sessionContext.user.id);
    const allRecsQuery = await this.store.query('recommendation', {
      filter: {
        user: this.sessionContext.user.id,
        'requesting-app': 'STRATEGY_FINDER',
      },
      include: 'user',
      sort: '-created-at',
      page: {
        offset: 0,
        limit: 3,
      },
    });
    const person = await this.store.findRecord<PersonModel>(
      'person',
      // @ts-expect-error type models
      this.sessionContext.user.person.id,
      {
        include: 'accounts.financial-institution,accounts.loans,user.answer-profile',
        reload: true,
      }
    );

    return {
      accounts: person.accounts,
      allRecommendations: allRecsQuery,
      loanSummary: loanSummary,
      mostRecentRecommendation: allRecsQuery?.[0],
      person,
      user: person.user,
    };
  }
}
